import { HikvisionCameraDirectionEnum } from '@zaoblako/shared/modules/cctv/enums/hikvision-camera-direction.enum';
import { HikvisionCameraDirectionEnumI18n } from '@zaoblako/shared/modules/cctv/i18n/hikvision-camera-direction-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hikvisionCameraDirectionName',
  standalone: true
})
export class HikvisionCameraDirectionNamePipe implements PipeTransform {
  public transform(direction: HikvisionCameraDirectionEnum): string {
    return HikvisionCameraDirectionEnumI18n[I18nLocalesEnum.RU_RU][direction] || '';
  }
}
